<mat-panel-title class="flex-1">
    <div class="flex-row gap-35 gap-lt-sm-0 start-center">
        <span class="customer-name flex-60px" [ngClass]="isMobile === true ? 'mobile-customer-name' : ''">
            {{ customer.customer }}
        </span>
        <colimo-customer-logo class="flex-lt-sm-40px flex-100px" [dashboard]="customer"></colimo-customer-logo>
    </div>
</mat-panel-title>
